import React, { useCallback, useEffect, useState } from 'react'
import styles from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/financial-terms.module.scss'
import { Button, Grid, Icon, NetworkIcon, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import { Table } from 'modules/Forms/Referral/LinkForm/subcomponents/FinancialTerms/subcomponents'

const FinancialTerms = ({ fields, className = '', isEditForm = false }) => {
  const { t } = useTranslation()
  const [terms, setTerms] = useState({})

  const [shown, setShown] = useState(true)

  useEffect(() => {
    setTerms(
      fields
        .getAll()
        .reduce(
          (
            acc,
            {
              adnetwork,
              financial_profile_type_alias,
              total_percent,
              client_percent,
              partner_percent,
              index,
            },
          ) => {
            const currentItem = acc?.[adnetwork.type] ?? { rates: [] }
            return {
              ...acc,
              [adnetwork.type]: {
                ...currentItem,
                adnetwork,
                shown: terms?.[adnetwork.type]?.shown ?? false,
                rates: [
                  ...currentItem.rates,
                  {
                    index,
                    financial_profile_type_alias,
                    total_percent,
                    client_percent,
                    partner_percent,
                  },
                ],
              },
            }
          },
          {},
        ),
    )
  }, [fields])

  const handleTriggerClick = useCallback(
    (type) => {
      setTerms((terms) => ({
        ...terms,
        [type]: { ...terms[type], shown: !terms[type].shown },
      }))
    },
    [setTerms],
  )

  if (isEmpty(terms)) {
    return null
  }

  return (
    <div className={clsx(className, styles['financial-terms'])}>
      <Grid
        alignItems={'center'}
        justifyContent={'between'}
        className={'margin-bottom-16'}
      >
        <Typography noMargin variant={'Body-20'} color={'Label-Fifth'}>
          {t('referral::referral_links_create.subheading')}
        </Typography>
        <Button
          variant={'ghost'}
          type={'button'}
          size={'s'}
          onClick={() => setShown(!shown)}
        >
          {t(`referral::referral_links_create.slide_${shown ? 'up' : 'down'}`)}
        </Button>
      </Grid>

      {shown &&
        Object.values(terms).map(
          ({ adnetwork: { id, type, alias }, rates, shown }) => (
            <div key={id} className={styles['financial-terms__item']}>
              <Grid
                justifyContent={'between'}
                alignItems={'center'}
                className={styles['financial-terms__heading']}
                wrap={false}
              >
                <Grid
                  fluid={false}
                  gap={8}
                  alignItems={'center'}
                  justifyContent={'start'}
                >
                  <NetworkIcon size={'s'} name={alias} rounded />
                  <Typography
                    noMargin
                    variant={'Body-20'}
                    color={'Label-Fifth'}
                  >
                    {t(`services::networks.${alias}`)}
                  </Typography>
                </Grid>
                <Button
                  className={clsx(
                    styles['financial-terms__trigger'],
                    styles[
                      `financial-terms__trigger_${shown ? 'open' : 'close'}`
                    ],
                  )}
                  onClick={() => handleTriggerClick(type)}
                  type={'button'}
                  variant={'ghost'}
                  size={'s'}
                  noLabel
                  startIcon={
                    <Icon
                      name={'arrow-up'}
                      size={'s'}
                      color={'Interface-Eighth'}
                    />
                  }
                />
              </Grid>

              {shown && <Table rates={rates} isEditForm={isEditForm} />}
            </div>
          ),
        )}
    </div>
  )
}
export default FinancialTerms

FinancialTerms.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.object,
  isEditForm: PropTypes.bool,
}
